import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from '~/components/Steps/Photos/PhotoLayout';

export function BackPassengersideAngle() {
  return <PhotoLayout {...photoLayoutConfig['backPassengersideAngle']} />;
}
